import React from 'react';
import { Descriptions, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import Markdown from 'react-markdown';
import { locale } from '../../config/config';
import { replaceBrWithNewline } from '../../utils/utils';
import styles from './index.module.css'; // 确保正确的 CSS 模块路径
const { Paragraph } = Typography;

export default function CardDetail({ data }) {
  const { file_name, version, products, desc, checksum, release_note } = data;

  return (
    <div className={styles.container}>
      <Descriptions labelStyle={{ fontWeight: 550 }}>
        {/* 文件名 */}
        <Descriptions.Item
          label={
            <strong>
              <FormattedMessage id='FileName' />
            </strong>
          }
        >
          {file_name || '-'}
        </Descriptions.Item>
        {/* 版本号 */}
        <Descriptions.Item
          label={
            <strong>
              <FormattedMessage id='Version' />
            </strong>
          }
        >
          {version || '-'}
        </Descriptions.Item>
      </Descriptions>

      <Descriptions
        column={1}
        labelStyle={{ fontWeight: 550 }}
        layout='vertical'
      >
        {/* 产品信息 */}
        <Descriptions.Item
          label={
            <strong>
              <FormattedMessage id='Products' />
            </strong>
          }
          contentStyle={{ display: 'block' }}
        >
          <Paragraph ellipsis={{ rows: 2, expandable: true, symbol: 'more' }}>
            {products.join(' , ') || '-'}
          </Paragraph>
        </Descriptions.Item>
        {/* 描述信息 */}
        <Descriptions.Item
          label={
            <strong>
              <FormattedMessage id='Descriptions' />
            </strong>
          }
        >
          {desc.en || '-'}
        </Descriptions.Item>
        {/* 发布说明 */}
        <Descriptions.Item
          label={
            <strong>
              <FormattedMessage id='ReleaseNotes' />
            </strong>
          }
        >
          <div className={styles.release_note}>
            <Markdown>{replaceBrWithNewline(release_note[locale])}</Markdown>
          </div>
        </Descriptions.Item>
        {/* 校验和信息 */}
        <Descriptions.Item
          label={
            <strong>
              <FormattedMessage id='Checksum' />
            </strong>
          }
        >
          {checksum || '-'}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
}
